import { useHistory } from 'react-router-dom';
import { ADHD } from 'components/shared/types';
import MailingList from 'components/assessment-email';
import { ADHD_ASSESSMENT_RESULT } from 'constants/localStorageKey';

const ADHDEmail = (): JSX.Element => {
  const history = useHistory();
  const data = localStorage.getItem(ADHD_ASSESSMENT_RESULT);

  const handleNextPage = () => {
    history.push('/adhd-assessment-result');
  };

  if (!data) {
    history.push('/adhd-self-test');
    return <></>;
  }

  return <MailingList handleNextPage={handleNextPage} condition={ADHD} />;
};

export default ADHDEmail;
